import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import UserList from "../components/reusable/usersList";
import { fetchAdminStatus } from "../services/adminService";
import { fetchEntries } from "../services/dataService";
import { deleteEntry } from "../services/deleteEntry";
import Card from "../components/reusable/card.jsx";
import ToggleButtons from "../components/reusable/toggleButtons.jsx";
import DateRangeWithLine from "../components/reusable/DateSelector1.jsx";
import LoadingScreen from "../components/reusable/loadingScreen";
import { motion, AnimatePresence } from "framer-motion";
import PageHeader from "../components/reusable/PageHeader.jsx";

function ViewEntries(props) {
  const [activeItem, setActiveItem] = useState("morning");
  const [morningEntries, setMorningEntries] = useState([]);
  const [eveningEntries, setEveningEntries] = useState([]);
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [userId, setUserId] = useState("");
  const [admin, setAdmin] = useState(false);
  const [initial, setIsInitial] = useState(true);
  const [loading, setLoading] = useState(false);
  const [username,setUserName]=useState("");
  const [name,setName]=useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveItemFromPath = () => {
    if (location.pathname.includes("/morning")) return "morning";
    if (location.pathname.includes("/evening")) return "evening";
    return "morning";
  };
  useEffect(() => {
    if (location.state) {
      setUserId(location.state.id);
      setUserName(location.state.username);
      setName(location.state.name);
    }
  }, [location.state]);
  useEffect(() => {
    setActiveItem(getActiveItemFromPath());
  }, [location.pathname]);

  useEffect(() => {
    setAdmin(fetchAdminStatus);
  }, []);

  const updateDates = (start, end) => {
    setStartDate(moment(start).format("YYYY-MM-DD"));
    setEndDate(moment(end).format("YYYY-MM-DD"));
    setIsInitial(false);
  };

  const handleDelete = async (itemId, time) => {
    try {
      await deleteEntry(itemId, time);
      fetchData();
    } catch (error) {
      console.error("Error deleting entry:", error);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const { morningEntries, eveningEntries } = await fetchEntries(startDate, endDate, userId, props.userId);
      setMorningEntries(morningEntries);
      setEveningEntries(eveningEntries);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!initial) fetchData();
  }, [startDate, endDate, userId, initial]);

  const renderContent = (entries, time) => (
    <motion.div
      key={time}
      initial={{ opacity: 0, y: time === "morning" ? -40 : 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: time === "morning" ? 40 : -40 }}
      transition={{ duration: 0.25 }}
      className="space-y-4 p-4 w-full"
    >
      <Card data={entries} isAdmin={admin} onDelete={handleDelete} time={time} role={props.role} UserKaName={name} />
    </motion.div>
  );

  return (
    <div className="p-1  w-full  mx-auto overflow-y-scroll ">
    <PageHeader title="View Milk Entries"/>
<div className="bg-white p-4 md:p-6 rounded-lg shadow-md mb-6 md:mb-8">
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 items-center">
    
    {/* Select User (Admin only) */}
    {props.role === "admin" && (
      <div className="relative">
        <label
          htmlFor="user-select"
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          Select User
        </label>
        <div className="relative">
          <UserList onSelectUser={setUserId} onUserChange={setName} selectedUser={username} />
        </div>
      </div>
    )}

    {/* Date Range Picker */}
    <div className="relative">
      <label
        htmlFor="date-range"
        className="block text-sm font-medium text-gray-700 mb-1"
      >
        Date Range
      </label>
      <div className="relative">
        <DateRangeWithLine handleChange={updateDates} />
      </div>
    </div>

    {/* Morning/Evening Toggle */}
    <div className="relative">
      <label
        htmlFor="entry-toggle"
        className="block text-sm font-medium text-gray-700 mb-1"
      >
        Select Time
      </label>
      <ToggleButtons
        name1="morning"
        name2="evening"
        onToggle={setActiveItem}
        selected={activeItem}
      />
    </div>

  </div>
</div>


      <div className="flex flex-col items-center  border border-gray-200 rounded-xl shadow bg-white  w-full ">
        <AnimatePresence mode="wait">
          {loading ? (
            <motion.div key="loading" className="p-4 text-center">
              <LoadingScreen />
            </motion.div>
          ) : activeItem === "morning"
          ? renderContent(morningEntries, "morning")
          : renderContent(eveningEntries, "evening")}
        </AnimatePresence>
      </div>
    </div>
  );
}

export default ViewEntries;